import "slick-carousel";

export const logoSlider = function ($block) {
  const slidesToShow = $(".block-logo-slider__logos").data("count");

  $(".block-logo-slider__logos")
    .not(".slick-initialized")
    .slick({
      arrows: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 2000,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
};
